export interface DecisionType {
  id: string
  name: string
  description: string
  icon: string
  default_ensemble_passes: string[]
  default_segment_hints: string[]
  default_stimulus_count: number
  recommended_industry_packs: string[]
  step1_question: string
}

export const DECISION_TYPES: DecisionType[] = [
  {
    id: 'churn_validation',
    name: 'Churn Validation',
    description: 'Why are customers actually leaving?',
    icon: 'TrendingDown',
    default_ensemble_passes: ['evidence_grounded', 'segment_echo', 'behavioral_prediction'],
    default_segment_hints: ['age_group', 'tenure', 'plan_type'],
    default_stimulus_count: 2,
    recommended_industry_packs: ['saas'],
    step1_question: 'Why are customers actually churning?',
  },
  {
    id: 'message_test',
    name: 'Message Test',
    description: 'Which message resonates?',
    icon: 'MessageSquare',
    default_ensemble_passes: ['evidence_grounded', 'segment_echo'],
    default_segment_hints: ['segment', 'region', 'age_group'],
    default_stimulus_count: 3,
    recommended_industry_packs: ['consumer'],
    step1_question: 'Which message performs best with each segment?',
  },
  {
    id: 'concept_test',
    name: 'Concept Test',
    description: 'Which concept performs best?',
    icon: 'Lightbulb',
    default_ensemble_passes: ['evidence_grounded', 'segment_echo', 'cross_segment_synthesis'],
    default_segment_hints: ['segment', 'region'],
    default_stimulus_count: 3,
    recommended_industry_packs: ['consumer'],
    step1_question: 'Which concept resonates most strongly?',
  },
  {
    id: 'pricing_reaction',
    name: 'Pricing Reaction',
    description: 'How does each segment respond to a pricing change?',
    icon: 'DollarSign',
    default_ensemble_passes: ['evidence_grounded', 'behavioral_prediction'],
    default_segment_hints: ['plan_type', 'arr_band', 'tenure'],
    default_stimulus_count: 2,
    recommended_industry_packs: ['saas', 'financial-services'],
    step1_question: 'How will each segment react to this pricing change?',
  },
  {
    id: 'claims_renewal',
    name: 'Claims / Renewal',
    description: 'Does this communication land as trustworthy?',
    icon: 'Shield',
    default_ensemble_passes: ['evidence_grounded', 'regulatory_language'],
    default_segment_hints: ['segment', 'region', 'age_group'],
    default_stimulus_count: 2,
    recommended_industry_packs: ['insurance', 'financial-services'],
    step1_question: 'Does this communication create trust with each segment?',
  },
  {
    id: 'agent_script',
    name: 'Agent Script',
    description: 'How would customers react to this conversation?',
    icon: 'Phone',
    default_ensemble_passes: ['evidence_grounded', 'segment_echo'],
    default_segment_hints: ['segment', 'tenure'],
    default_stimulus_count: 2,
    recommended_industry_packs: ['insurance', 'consumer'],
    step1_question: 'How would each segment respond to this script?',
  },
]
